import { ICellRendererParams } from 'ag-grid-community'
import { styled } from '@mui/material'
import { WbsItemStatus } from '../../../../../domain/entity/WbsItemEntity'
import { getWbsItemStatusDeepColorCode } from '../../../../../lib/functions/wbsItem'
import { SprintReportRow } from '../../model/sprintReportRow'

type Props = ICellRendererParams<SprintReportRow>

export const SprintReportWbsItemStatusCellRenderer = (props: Props) => {
  const key = props.data?.key
  // SprintReportKey と WbsItemStatus は別 enum だが TODO/DOING/REVIEW/DONE/DISCARD は同値
  if (!key || !(Object.values(WbsItemStatus) as string[]).includes(key)) {
    return <>{props.value}</>
  }
  const status = key as unknown as WbsItemStatus
  return (
    <Cell className="sevend-ag-cell">
      <StatusDot
        $color={getWbsItemStatusDeepColorCode(status)}
        $bordered={status === WbsItemStatus.TODO}
      />
      <div>{props.value}</div>
    </Cell>
  )
}

const Cell = styled('div')({
  padding: 0,
})

const StatusDot = styled('div', {
  shouldForwardProp: prop => prop !== '$color' && prop !== '$bordered',
})<{ $color: string; $bordered: boolean }>(({ $color, $bordered }) => ({
  backgroundColor: $color,
  height: '10px',
  width: '10px',
  margin: '0 5px 0 0',
  border: $bordered ? '1px solid #DDDDDD' : undefined,
}))
